import React, { useEffect, useRef, useState } from "react";
import { Timeline as AntTimeline, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { getTimelineDetails } from "../../models/patientSlice";
import dayjs from "dayjs";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import Loader from "../../utils/Spinners";

interface TimelineProps {
  caseId: number | null;
  visitId: number | null;
  isTimelineVisible: boolean | null;
  isDocumentDrawer?: boolean;
}

const Timeline: React.FC<TimelineProps> = ({
  caseId,
  visitId,
  isTimelineVisible,
  isDocumentDrawer,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { patients } = useSelector((state: RootState) => state);

  const [collapsed, setCollapsed] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState("auto");

  // useEffect(() => {
  //   if (contentRef.current) {
  //     setContentHeight(
  //       collapsed ? "0px" : 'auto'
  //     );
  //   }
  // }, [collapsed, patients.timelineDetails]);


  useEffect(() => {
    if (contentRef.current) {
      if (collapsed) {
        setContentHeight("0px");
      } else {
        // Get the actual scroll height when expanding
        setContentHeight(`${contentRef.current.scrollHeight}px`);
      }
    }
  }, [collapsed, patients.timelineDetails]);

  useEffect(() => {
    if (caseId && visitId) {
      dispatch(getTimelineDetails({ caseId, visitId }));
    }
  }, [caseId, visitId, isTimelineVisible]);

  return (
    <>
      {patients?.isFetchingTimeLine ? (
        <Loader />
      ) : (
        <div style={styles.container}>
          {!isDocumentDrawer && (
            <div style={styles.headerContainer}>
              <h3 style={styles.header}>Timeline :</h3>
              <Button
                size="small"
                icon={collapsed ? <DownOutlined /> : <UpOutlined />}
                onClick={() => setCollapsed((prev) => !prev)}
              />
            </div>
          )}
          <div
            style={{
              ...styles.timeline,
              display: collapsed ? "none" : "block",

              // maxHeight: contentHeight,
              overflow: "auto",
              maxHeight: "70vh",
               scrollBehavior: "smooth",
                    WebkitOverflowScrolling: "touch",
                    scrollbarWidth: "thin",
                    scrollbarColor: "#c1c1c1 #f1f1f1",
              // transition: "max-height 0.3s ease",
              // padding: "20px",
            }}
            ref={contentRef}
          >
            <AntTimeline style={{ padding: "10px 20px" }}>
              {patients?.timelineDetails?.map((item, index) => (
                <AntTimeline.Item
                  key={index}
                  dot={
                    <div style={styles.outerEllipse}>
                      {index === 0 && <div style={styles.innerEllipse}></div>}
                    </div>
                  }
                >
                  <div style={styles.content}>
                    {item?.userName && item?.userRole ? (
                      <span>
                        <h4 style={styles.title}>
                          {`${item?.status} by ${item?.userName}`}
                          <span
                            style={{ fontWeight: "normal" }}
                          >{`(${item?.userRole})`}</span>
                        </h4>
                      </span>
                    ) : (
                      <h4 style={styles.title}>{item?.status}</h4>
                    )}

                    {item?.stageRemarks && (
                      <p style={styles.description}>
                        {item?.stageRemarks ?? "-"}
                      </p>
                    )}
                    <p style={styles.date}>
                      {dayjs(item?.createdAt).format("DD MMM YYYY , hh:mm A") ??
                        "-"}
                    </p>
                    {/* {item.downloadLink && (
                  <a href={item.downloadLink} style={styles.link} download>
                    Download
                  </a>
                )} */}
                  </div>
                  {/* Line between items */}
                  {/* {index < items.length - 1 && <div style={styles.line}></div>} */}
                </AntTimeline.Item>
              ))}
            </AntTimeline>
          </div>
        </div>
      )}
    </>
  );
};

// Styles
const styles: { [key: string]: React.CSSProperties } = {
  container: { fontFamily: "Arial, sans-serif", backgroundColor: "#E5F3F3" },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 0,
    border: "0.4px solid #A6A6A6",
    borderRadius: "10px 10px 0px 0px",
    padding: "5px 10px",
    background: "#004C8F",
    color: "white",
  },
  header: {
    marginBottom: "0px",
    // border: "0.4px solid #A6A6A6",
    borderRadius: "10px 10px 0px 0px",
    // padding: "10px 20px",
    background: "#004C8F",
    color: "white",
    fontSize: "14px"
  },
  timeline: { border: "0.4px solid #A6A6A6", background: "#f8f9fa" },
  content: { gap: "4px" },
  title: {
    marginBottom: "4px",
    fontWeight: "600",
    fontSize: "12px",
    font: "inter",
    lineHeight: "19.36px",
  },
  description: {
    marginBottom: "4px",
    fontWeight: "400",
    fontSize: "12px",
    font: "inter",
    lineHeight: "16.94px",
  },
  date: {
    marginBottom: "4px",
    fontWeight: "400",
    fontSize: "12px",
    font: "inter",
    lineHeight: "16.94px",
    color: "#808184",
  },
  link: {
    fontWeight: "600",
    fontSize: "12px",
    font: "inter",
    lineHeight: "16.94px",
    color: "#008B8B",
  },
  // Outer ellipse styles
  outerEllipse: {
    width: "20px",
    height: "20px",
    border: "2px solid #004C8F",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    backgroundColor: "white",
  },
  // Inner ellipse styles (appears when active)
  innerEllipse: {
    width: "10px",
    height: "10px",
    backgroundColor: "#004C8F",
    border: "2px solid #004C8F",
    borderRadius: "50%",
  },
  // Line styles between items
  line: {
    width: "68px",
    border: "1px solid #C4C4C4",
    position: "absolute",
    top: "20px",
    left: "10px",
    transform: "rotate(-90deg)",
  },
};

export default Timeline;
